import { Auth } from "aws-amplify";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/User/UserContext";
import classes from "./LoadingScreen.module.css";
import { observer } from 'mobx-react';
import { useStore } from "../../../Hooks/useStore";

function LoadingScreen() {
  const { user, setUser } = useUser();


  const { rootStore } = useStore();

  const navigation = useNavigate();

  useEffect(() => {
    // Auth.currentUserInfo().then((data) => {
    //   const user = {
    //     username: data.username,
    //     ...data.attributes,
    //   };
    //   setUser(user);
    // });
    let uInfo = localStorage.getItem("userinfo");
    if(uInfo) {
      console.log("uInfo in loading", uInfo);
      const userinformation = JSON.parse(uInfo);
      setUser(userinformation);
    }
  }, []);

  useEffect(() => {
    const redirectRoute = localStorage.getItem("redirectRoute");
    if (redirectRoute) {
      navigation(redirectRoute);
      localStorage.removeItem("redirectRoute");
    }
  }, [user]);
  

  useEffect(() => {
    rootStore.loadingStore.setShowLoader(true);
    if (user) {
      rootStore.loadingStore.setShowLoader(false);
      switch (user["custom:type"]) {
        case "ems":
          navigation("medical-emergencies");
          break;
        case "coordinator":
          navigation("coordinator");
          break;
        default:
          navigation("home");
          break;
      }
    }
  }, [user]);

  return <div className={classes.mainContainer}></div>;
}

export default observer(LoadingScreen);
